import React, { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { http } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("mf_token");
    if (!token) { setLoading(false); return; }
    http.get("/auth/me").then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("mf_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await http.post("/auth/login", { email, password });
    localStorage.setItem("mf_token", r.data.token);
    setUser(r.data.user);
    navigate("/dashboard");
    return r.data.user;
  };

  const register = async (payload) => {
    const r = await http.post("/auth/register", payload);
    localStorage.setItem("mf_token", r.data.token);
    setUser(r.data.user);
    navigate("/dashboard");
    return r.data.user;
  };

  const refreshUser = async () => {
    try {
      const r = await http.get("/auth/me");
      setUser(r.data);
      return r.data;
    } catch (_) { return null; }
  };

  const logout = () => {
    localStorage.removeItem("mf_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
